const InstagramActionTypes = {
	FETCH_INSTAGRAM_POSTS_START: 'FETCH_INSTAGRAM_POSTS_START',
	FETCH_INSTAGRAM_POSTS_SUCCESS: 'FETCH_INSTAGRAM_POSTS_SUCCESS',
	FETCH_INSTAGRAM_POSTS_FAILURE: 'FETCH_INSTAGRAM_POSTS_FAILURE',
};

export default InstagramActionTypes;
